import UnderDevelopment from "./components/specials/UnderDevelopment";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import AddEvent from "./pages/contributer/AddEvent";
import AddPlace from "./pages/contributer/AddPlace";
import AddSpecialEvent from "./pages/contributer/AddSpecialEvent";
import AdventureEventDetails from "./pages/contributer/AdventureEventDetails";
import Commercials from "./pages/contributer/Commercials";
import CultureEventDetails from "./pages/contributer/CultureEventDetails";
import ContributerDashboard from "./pages/contributer/Dashboard";
import DateEventDetails from "./pages/contributer/DateEventDetails";
import EditPlace from "./pages/contributer/EditPlace";
import EventDetails from "./pages/contributer/EventDetails";
import KidsPlaceDetails from "./pages/contributer/KidsPlaceDetails";
import MyPlaces from "./pages/contributer/MyPlaces";
import Profile from "./pages/contributer/Profile";
import ResturantDetail from "./pages/contributer/ResturantDetail";
import SpecialEventDetails from "./pages/contributer/SpecialEventDetails";
import SportsEventDetails from "./pages/contributer/SportsEventDetails";
import FAQ from "./pages/FAQ";
import Home from "./pages/user/Home";
import Saved from "./pages/user/Saved";

import ResturantDetailUser from "./pages/user/ResturantDetail";
import SpecialEventDetailsUser from "./pages/user/SpecialEventDetails";
import SportsEventDetailsUser from "./pages/user/SportsEventDetails";
import EventDetailsUser from "./pages/user/EventDetails";
import KidsPlaceDetailsUser from "./pages/user/KidsPlaceDetails";
import CultureEventDetailsUser from "./pages/user/CultureEventDetails";
import DateEventDetailsUser from "./pages/user/DateEventDetails";
import AdventureEventDetailsUser from "./pages/user/AdventureEventDetails";
import Directions from "./pages/user/Directions";
import ForgotPassword from "./pages/auth/ForgotPassword";
import { ResetPassword } from "./pages/auth/ResetPassword";
import AddContributors from "./pages/contributer/AddComercials";
import AddComercials from "./pages/contributer/AddComercials";
import UserCommercials from "./pages/user/UserCommercials";

//common routes are common for contributor and user , they will only be availble when user is logged in

export const routes = {
  authRoutes: [
    { path: "/", component: Login },
    { path: "/login", component: Login },
    { path: "/signup", component: Signup },
    { path: "/forgot-password", component: ForgotPassword },
    { path: "/reset-password", component: ResetPassword },

    { path: "*", component: UnderDevelopment },
  ],
  userRoutes: [
    { path: "/", component: Home },
    { path: "*", component: UnderDevelopment },
    { path: "/places/resturant/:id", component: ResturantDetailUser },
    { path: "/places/special-event/:id", component: SpecialEventDetailsUser },
    { path: "/places/kids/:id", component: KidsPlaceDetailsUser },
    { path: "/events/event/:id", component: EventDetailsUser },
    { path: "/places/culture/:id", component: CultureEventDetailsUser },
    { path: "/places/date/:id", component: DateEventDetailsUser },
    { path: "/places/sports/:id", component: SportsEventDetailsUser },
    { path: "/places/adventure/:id", component: AdventureEventDetailsUser },
    { path: "/saved", component: Saved },
    { path: "/directions", component: Directions },
    { path: "/commercials", component: UserCommercials },
  ],
  contributerRoutes: [
    { path: "/", component: ContributerDashboard },
    { path: "/places", component: MyPlaces },
    { path: "/places/addplaces", component: AddPlace },
    { path: "/places/editplace", component: EditPlace },
    { path: "/places/resturant/:id", component: ResturantDetail },
    { path: "/places/special-event/:id", component: SpecialEventDetails },
    { path: "/places/kids/:id", component: KidsPlaceDetails },

    { path: "/places/culture/:id", component: CultureEventDetails },
    { path: "/places/date/:id", component: DateEventDetails },
    { path: "/places/sports/:id", component: SportsEventDetails },
    { path: "/places/adventure/:id", component: AdventureEventDetails },
    { path: "*", component: UnderDevelopment },
    { path: "/events/addEvent", component: AddEvent },
    { path: "/events/event/:id", component: EventDetails },
    { path: "/events/addSpecialEvent", component: AddSpecialEvent },
    { path: "/commercials", component: Commercials },
    { path: "/commercials/addComercials", component: AddComercials },
  ],
  commonRoutes: [
    { path: "/faq", component: FAQ },
    { path: "/profile", component: Profile },
  ],
};
